
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "VEmployerVisaCases",

  setup() {
    return {};
  },
});
